import { render, staticRenderFns } from "./SupplierPurchaseGoalTable.vue?vue&type=template&id=15d79a4a&scoped=true"
import script from "./SupplierPurchaseGoalTable.vue?vue&type=script&lang=js"
export * from "./SupplierPurchaseGoalTable.vue?vue&type=script&lang=js"
import style0 from "./SupplierPurchaseGoalTable.vue?vue&type=style&index=0&id=15d79a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d79a4a",
  null
  
)

export default component.exports